import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// Icon import example as per your instruction
import { FaCircle } from "react-icons/fa";
import Frame1 from "../../../assets/Frame.png";
// import "./PredictionSection.css";
import headerIcon from "../../../assets/image 4.png";
import { Carousel } from "react-bootstrap";
import NoResultCard from "./NoResultCard";


const PredictionSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const { userInfo } = useSelector((state) => state.user); // Logic to check login

  // Sample slides for new design carousel
  const predictionSlides = [
    [
      { title: "Distance", items: [{ rank: 1, name: "Predict Name" }, { rank: 5, name: "Predict Name" }] },
      { title: "Time", items: [{ rank: 1, name: "Predict Name" }, { rank: 5, name: "Predict Name" }] },
      { title: "Class", items: [{ rank: 1, name: "Predict Name" }, { rank: 5, name: "Predict Name" }, { rank: 5, name: "Predict Name" }] },
      { title: "Race Course", items: [{ rank: 1, name: "Predict Name" }, { rank: 5, name: "Predict Name" }, { rank: 5, name: "Predict Name" }] },
      { title: "Pedigree", items: [{ rank: 1, name: "Predict Name" }, { rank: 1, name: "Predict Name" }, { rank: 1, name: "Predict Name" }, { rank: 1, name: "Predict Name" }] },
      { title: "Overall", items: [{ rank: 1, name: "Predict Name" }, { rank: 1, name: "Predict Name" }, { rank: 1, name: "Predict Name" }, { rank: 1, name: "Predict Name" }] },
    ],
    [
      { title: "Distance", items: [{ rank: 2, name: "Predict Name" }, { rank: 4, name: "Predict Name" }] },
      { title: "Time", items: [{ rank: 3, name: "Predict Name" }, { rank: 6, name: "Predict Name" }] },
      { title: "Class", items: [{ rank: 1, name: "Predict Name" }, { rank: 2, name: "Predict Name" }, { rank: 4, name: "Predict Name" }] },
      { title: "Race Course", items: [{ rank: 2, name: "Predict Name" }, { rank: 3, name: "Predict Name" }, { rank: 7, name: "Predict Name" }] },
      { title: "Pedigree", items: [{ rank: 2, name: "Predict Name" }, { rank: 3, name: "Predict Name" }, { rank: 5, name: "Predict Name" }, { rank: 8, name: "Predict Name" }] },
      { title: "Overall", items: [{ rank: 1, name: "Predict Name" }, { rank: 2, name: "Predict Name" }, { rank: 3, name: "Predict Name" }, { rank: 4, name: "Predict Name" }] },
    ],
  ];

  return (

    <div>
      <div className="d-flex">
              <div className="race-post-header">
                <h2 className="race-post-title">{t("PREDICTION")}</h2>
              </div>
              <div className="race-post-logo-wrap">
                <img
                  src={headerIcon}
                  alt="icon"
                  style={{ width: "45px", opacity: 0.3, margin: "0 0 4px 0px" }}
                />
              </div>
            </div>
    <div className="predict-main-container">
      <div className="predict-header">
        {userInfo && 
         <h2 className="predict-title">
          <span className="predict-live-dot"><FaCircle /> {t("live")}</span>
        </h2>
        }
      </div> 

      <div className="predict-content-wrapper">
        
        {/* --- UI 1: Before Login (Guest Account) --- */}
        {!userInfo ? (
          <div className="predict-guest-view">
            <div className="predict-watermark-overlay"></div>
            <div className="predict-guest-content">
              <p className="predict-guest-text">
                {cookiedata === "en" ? (
                  <>
                    You're currently using a Guest Account.<br />
                    To explore all features, please Signin to continue
                  </>
                ) : (
                  <>
                    أنت تستخدم حساب الزيارة، سجّل دخولك عشان تقدر تستخدم كل المزايا<br />
                    لاستكشاف جميع الميزات، يرجى تسجيل الدخول للمتابعة
                  </>
                )}
              </p>
              <div className="predict-auth-buttons">
                <button className="predict-btn-signin" onClick={() => navigate("/login")}>{t("Login")}</button>
                <button className="predict-btn-register" onClick={() => navigate("/register")}>{t("Register")}</button>
              </div>
            </div>
          </div>
        ) : (
          /* --- UI 2: After Login (Prediction Grid with Carousel) --- */
          predictionSlides && predictionSlides.length > 0 ? (
            <Carousel
              controls={predictionSlides.length > 1}
              indicators={false}
              touch={true}
              interval={2000000}
            >
              {predictionSlides.map((predictionData, slideIndex) => (
                <Carousel.Item key={slideIndex}>
                  <div className="predict-user-view">
                    <div className="predict-grid-layout">
                      {predictionData.map((category, index) => (
                        <div key={index} className="predict-category-group">
                          <h4 className="predict-category-title">{category.title}</h4>
                          <div className="predict-items-stack">
                            {category.items.map((item, idx) => (
                              <div key={idx} className="predict-item-card">
                                <span className="predict-rank">{item.rank}</span>
                                <div className="predict-item-icon-wrap">
                                  <img src={Frame1} alt="icon" />
                                </div>
                                <span className="predict-horse-name">{item.name}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <NoResultCard title="Pick_Race_Experts" />
          )

        )}

      </div>
    </div>
    </div>
  );
};

export default PredictionSection;
